export class NotificationsAPI {

    constructor() {
        this.id_notificacion = null;
        this.vista = false;
        this.id_usuario = null;
        this.id_admision = null;
        this.id_historia = null;
        this.asunto = null;
        this.remitente = null;
        this.notificacion = "";
        this.id_notificaciones_tipo = null;
        this.fecha_notificacion = null;
        this.html_notificacion = '<span></span>';
    }

    checkStatus(response) {
        switch (response.status) {
            case 500:
                throw new Error(`${response.status} - Server Error!`);
            case 403:
                throw new Error(`${response.status} - Unauthenticated!`);
            case 404:
                throw new Error(`${response.status} - Not Found!`);
            default:
                break;
        }
    }

    async addNotification() {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}notificaciones/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(this)
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = null;
        });
        return datos;
    }

    async sendHTMLNotification() {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}notificaciones/enviar-html`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id_notificacion: this.id_notificacion, html_notificacion: this.html_notificacion })
        }).then(response => {
            this.checkStatus(response);
            return true;
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = false;
        });
        return datos;
    }

    async listNotifications() {
        let datos;
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}notificaciones/listar?id_usuario=${usuario.id_usuario}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }

    async markNotification(notification,mark) {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}notificaciones/marcar`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({id_notificacion:notification.id_notificacion,vista:mark})
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }
    
}